import {
  DocumentReference,
  serverTimestamp,
  Transaction as FirestoreTransaction,
  type UpdateData,
} from 'firebase/firestore';
import type { TransactionData, TransactionDeletionReason } from '@shared/types';

import { cleanDataToFirestore } from './converters';

export interface SoftDeleteTransactionProps {
  deletedBy: string;
  deletionReason: Exclude<TransactionDeletionReason, 'providerRemoved'>;
}

interface TransactionOperationalState {
  deletedAt?: Date | null;
  deletedBySource?: boolean | null;
  deletionReason?: TransactionDeletionReason | null;
}

export const buildTransactionSoftDeleteData = (
  props: SoftDeleteTransactionProps,
): UpdateData<TransactionData> => ({
  deletedAt: serverTimestamp(),
  deletedBy: props.deletedBy,
  deletionReason: props.deletionReason,
});

export const softDeleteTransactionInTransaction = (
  transaction: FirestoreTransaction,
  ref: DocumentReference<TransactionData>,
  props: SoftDeleteTransactionProps,
) => {
  transaction.update(
    ref,
    cleanDataToFirestore(buildTransactionSoftDeleteData(props)),
  );
};

export const isTransactionOperationallyActive = (
  data: TransactionOperationalState,
): boolean =>
  (data.deletedAt === undefined || data.deletedAt === null) &&
  (data.deletionReason === undefined || data.deletionReason === null) &&
  data.deletedBySource !== true;
